/**
 * 基础菜单 商品管理
 */
<template>
  <div class="personal-data">
    <div class="head">
      <div class="head-left"> 
        <p class="title">个人资料</p>
        <p class="tiao"></p>
      </div>
      <!-- <div>
        <el-button :class="type==1?'':'buttons'" size="small" :type="type==1?'warning':''" round @click="onButton(1)">个人资料</el-button>
        <el-button :class="type==2?'':'buttons'" size="small" :type="type==2?'warning':''" round @click="onButton(2)">企业认证</el-button>
      </div> -->
    </div>
    <div class="nav-list">
      <ul>
        <li class="type" :class="cur==1?'cur':''" @click="onCur(1)">个人资料</li>
        <li class="bar divider">|</li>
        <li class="type" :class="cur==2?'cur':''" @click="onCur(2)">实名认证</li>
        <li class="bar divider">|</li>
        <li class="type" :class="cur==3?'cur':''" @click="onCur(3)">身份认证</li>
      </ul>
    </div>

    <!-- 个人资料 -->
    <personal v-if="cur==1 && code==0" @getUserInfo="getUserInfo" :userInfo="userInfo"></personal>

    <!-- 实名认证 -->
    <certification v-if="cur==2" @getUserInfo="getUserInfo" :userInfo="userInfo"></certification>
    
    <!-- 身份认证 -->
    <enterprise v-if="cur==3" @getUserInfo="getUserInfo" :userInfos="userInfo"></enterprise>
  </div>
</template>

<script>
import personal from '../../components/data/personal.vue'
import enterprise from '../../components/data/enterprise.vue'
import certification from '../../components/data/certification.vue'
import { userInfo } from '../../api/userMG'
export default {
  // 注册组件
  components: {
    personal,
    enterprise,
    certification
  },
  data() {
    return {
      type:1,
      cur:1,
      userInfo:{},
      showSon:false,
      code:1
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.$emit("breadcrumb",'个人资料');
    this.getUserInfo();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    onButton(e){
      this.type = e
    },
    onCur(e){
      this.cur = e;
    },
    async getUserInfo(){
      await userInfo().then(res => {
        console.log('用户信息',res);
        this.code = res.code;
        this.userInfo = res.data;
        localStorage.setItem('auditStatus', res.data.auditStatus);
        localStorage.setItem('realName', res.data.realName);
        this.showSon = true;
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style scoped>
  .personal-data{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .tiao{
    height: 3px;
    background: #f35903;
    border-radius: 4px;
  }
  .el-button--small.is-round {
    padding: 7px 26px;
  }
  .buttons{
    color: #f35903;
    border:1px solid #f35903;
  }
  .buttons:hover{
    background: none;
  }
  .nav-list{
    margin-top: 20px;
    margin-bottom: 32px;
  }
  .nav-list ul{
    display: flex;
    align-items: center;
  }
  .nav-list ul li{
    font-size: 13px;
    padding: 10px 0;
    /* margin:  0 10px; */
    cursor: pointer;
  }
  .divider{
    margin:  0 30px;
  }
  .nav-list ul .bar{
    color: #e1e2e6;
  }
  .nav-list ul .type{
    color: black;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c;
  }

</style>

 
 


// WEBPACK FOOTER //
// src/views/personal/personal.vue